/* Other Pitch editorial theme. No third-party libraries, tracking, paid asset paths or price constants. */
export function findOverlaps(items) {
  const seen = new Map(); const overlaps = new Set();
  for (const item of items) for (const component of new Set(item.components || [])) {
    if (seen.has(component) && seen.get(component) !== item.key) overlaps.add(component);
    else seen.set(component, item.key);
  }
  return [...overlaps];
}
export function canPurchase({globalApproval, policiesApproved, productReady, available, key}) {
  return globalApproval === true && policiesApproved === true && productReady === true && available === true && key !== 'men';
}
export function recommend(keys, scope) {
  const allowed = ['home','pet','family','women','celebration','gift','wedding'];
  const unique = [...new Set(keys)].filter(k => allowed.includes(k));
  if (!unique.length) return [];
  if (scope === 'one' || unique.length === 1) return unique.slice(0,1);
  const offers = [ ['home-paws',['home','pet']], ['family-foundations',['home','family']], ['thoughtful-occasions',['celebration','gift']], ['wedding-everyday',['wedding','home','gift']], ['current-collection',allowed] ];
  const exact = offers.find(([,parts]) => parts.length === unique.length && parts.every(k => unique.includes(k)));
  return exact ? [exact[0]] : unique.slice(0,2);
}
export async function requestCartAdd(root, data, fetcher = fetch) {
  if (typeof root !== 'string' || !root.startsWith('/') || root.startsWith('//')) throw new Error('Invalid storefront route');
  const response = await fetcher(root + 'cart/add.js', {method:'POST',body:data,credentials:'same-origin',headers:{Accept:'application/json'}});
  const result = await response.json();
  if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Shopify did not accept this cart change.');
  return result;
}
if (typeof document !== 'undefined') {
  document.documentElement.classList.add('js');
  const ui = JSON.parse(document.getElementById('op-ui')?.textContent || '{}');
  const root = window.Shopify?.routes?.root || '/';
  const live = document.getElementById('op-live');
  const announce = text => { if (live) live.textContent = text; };
  const openers = new WeakMap();
  function openDialog(dialog, opener) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    openers.set(dialog, opener || document.activeElement);
    if (!dialog.open) dialog.showModal();
    return true;
  }
  function closeDialog(dialog) { if (dialog?.open) dialog.close(); }
  function bindDialog(dialog) {
    if (!dialog || dialog.dataset.opBound) return;
    dialog.dataset.opBound = 'true';
    dialog.addEventListener('close', () => { const opener=openers.get(dialog); if (opener?.isConnected) opener.focus(); });
    dialog.addEventListener('click', event => {
      const rect=dialog.getBoundingClientRect();
      if (event.target===dialog && (event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom)) closeDialog(dialog);
    });
  }
  document.querySelectorAll('dialog').forEach(bindDialog);
  document.addEventListener('click', async event => {
    const element=event.target instanceof Element ? event.target : null;
    if (!element) return;
    const close=element.closest('[data-close-dialog]');
    if (close) {closeDialog(close.closest('dialog'));return;}
    const menu=element.closest('[data-open-menu]');
    if (menu) {openDialog(document.getElementById('op-menu'),menu);return;}
    const menuLink=element.closest('#op-menu a');
    if (menuLink) closeDialog(document.getElementById('op-menu'));
    const cart=element.closest('[data-open-cart]');
    if (cart && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      const dialog=document.getElementById('op-cart-dialog');
      if (openDialog(dialog,cart)) event.preventDefault();
      return;
    }
    const preview=element.closest('a[data-preview]');
    if (preview && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      const dialog=document.getElementById('op-preview');
      const image=document.getElementById('op-preview-image');
      const caption=preview.querySelector('img')?.alt || preview.getAttribute('aria-label') || 'Actual Other Pitch file preview';
      if (dialog && image) {
        image.src=preview.href;image.alt=caption;
        document.getElementById('op-preview-caption').textContent=caption;
        let original=document.getElementById('op-preview-original');
        if (!original) {original=document.createElement('a');original.id='op-preview-original';original.target='_blank';original.rel='noopener';original.textContent='Open full-size image in a new tab';dialog.querySelector('.preview-scroll').append(original);}
        original.href=preview.href;
        if (openDialog(dialog,preview)) event.preventDefault();
      }
      return;
    }
    const keep=element.closest('[data-keep-selection]');
    if (keep) {keep.closest('[data-overlap-notice]').querySelector('p').textContent='You chose to keep the present selection for review. No item was removed, replaced or added. Overlapping content and license limits still apply.';keep.remove();return;}
    const privacy=element.closest('[data-privacy-preferences]');
    if (privacy) {
      const banner=window.Shopify?.privacyBanner || window.privacyBanner;
      if (typeof banner?.showPreferences==='function') {try {await banner.showPreferences();} catch {announce(ui.consentUnavailable);}}
      else announce(ui.consentUnavailable);
    }
  });
  document.addEventListener('submit',async event => {
    const form=event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('op-product-form')) return;
    const button=form.querySelector('[name="add"]');
    if (!button || button.disabled) return;
    event.preventDefault();
    const error=form.querySelector('.form-error');
    button.disabled=true;button.setAttribute('aria-busy','true');if (error) {error.hidden=true;error.textContent='';}
    const data=new FormData(form);data.set('quantity','1');data.set('sections','op-cart-panel');data.set('sections_url',window.location.pathname);
    try {
      // Inspect current cart before adding another identical single-license variant. Never infer past ownership.
      const beforeResponse=await fetch(root+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
      if (!beforeResponse.ok) throw new Error(ui.error);
      const before=await beforeResponse.json();
      if (before.items.some(item=>String(item.variant_id)===String(data.get('id')))) throw new Error(ui.already);
      const result=await requestCartAdd(root,data);
      const sectionHtml=result.sections?.['op-cart-panel'];
      if (typeof sectionHtml==='string') {
        const parsed=new DOMParser().parseFromString(sectionHtml,'text/html');
        const next=parsed.getElementById('shopify-section-op-cart-panel');
        const current=document.getElementById('shopify-section-op-cart-panel');
        if (next && current) {current.replaceWith(next);bindDialog(document.getElementById('op-cart-dialog'));}
      }
      announce(ui.added);
      try {
        const response=await fetch(root+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
        if (response.ok) {const actual=await response.json();document.querySelectorAll('[data-cart-count]').forEach(n=>n.textContent=String(actual.item_count));}
      } catch { announce(ui.added+' '+ui.viewCart); }
      if (sectionHtml) openDialog(document.getElementById('op-cart-dialog'),button);
      else {const link=document.createElement('a');link.href=root+'cart';link.textContent=ui.viewCart;error?.append(document.createTextNode(ui.added+' '),link);if(error)error.hidden=false;}
    } catch (exception) {
      const message=exception instanceof TypeError ? ui.error : (exception.message || ui.error);
      if (error) {error.textContent=message;error.hidden=false;}announce(message);
    } finally {button.disabled=false;button.removeAttribute('aria-busy');}
  });
  // Pointer tilt is confined to the visual covers; all text/prices/controls stay still.
  function enablePreferences() {const banner=window.Shopify?.privacyBanner||window.privacyBanner;if(typeof banner?.showPreferences==='function')document.querySelectorAll('[data-privacy-preferences]').forEach(n=>n.hidden=false);}
  enablePreferences();window.addEventListener('load',enablePreferences,{once:true});
  // Finder uses only explicit, non-sensitive task choices and stores nothing.
  const finder=document.getElementById('op-finder');
  const catalogue=JSON.parse(document.getElementById('op-finder-data')?.textContent||'[]');
  finder?.addEventListener('submit',event=>{
    event.preventDefault();const data=new FormData(finder);const keys=data.getAll('need');const picks=recommend(keys,data.get('scope'));const result=document.getElementById('finder-result');result.replaceChildren();
    if(!picks.length){result.textContent='Choose at least one task, or browse the categories below.';return;}
    const offers={'home-paws':'Home & Paws','family-foundations':'Family Foundations','thoughtful-occasions':'Thoughtful Occasions','wedding-everyday':'Wedding to Everyday','current-collection':'The Current Collection'};
    for(const key of picks){const item=catalogue.find(x=>x.key===key);const box=document.createElement('div');box.className='finder-result-card';const a=document.createElement('a');a.href=item?.url||(root+'products/op-r1-'+key);a.textContent=item?.title||offers[key];const p=document.createElement('p');p.textContent=(item?'A starting point based on a task you selected.':'This combination contains exactly the task categories you selected.')+' Paper and XLSX options are included; software compatibility must be checked. No purchase history or personal profile was used.';box.append(a,p);result.append(box);}
    if(keys.length>picks.length && picks.every(k=>catalogue.some(x=>x.key===k))){const note=document.createElement('p');note.textContent='Start with one of these two selected areas, then browse the remaining categories below. No unrelated collection has been substituted.';result.append(note);}
  });
  document.addEventListener('shopify:section:load',()=>{document.querySelectorAll('dialog').forEach(bindDialog);enablePreferences();});
}
